import { Money } from '@ap/interface-bspc-core';
import { AssetDetail } from '@ap/ap-interface-apix-hypotheken-berekening';

export class AssetDetailBuilder {
    private surplusValue: Money;
    private savings: Money;
    private requiredAsset: Money;

    withSurplusValue(surplusValue: Money): this {
        this.surplusValue = surplusValue;
        return this;
    }

    withSavings(savings: Money): this {
        this.savings = savings;
        return this;
    }

    withRequiredAsset(requiredAsset: Money): this {
        this.requiredAsset = requiredAsset;
        return this;
    }

    build(): AssetDetail {
        return {
            surplus_value: this.surplusValue,
            savings: this.savings,
            required_asset: this.requiredAsset
        } as AssetDetail;
    }
}

export const aAssetDetail = new AssetDetailBuilder();
